module.exports = __webpack_public_path__ + "static/media/23.6e6af0a8.svg";